import React from 'react'

export const MARK_LINE_HEIGHT = 'lineHeight';

export function renderLineHeightLeaf({ children, leaf }) {

    if (leaf[MARK_LINE_HEIGHT]) {

        const styles = {
            lineHeight: leaf[MARK_LINE_HEIGHT],
        };
        return (
            <span style={styles}>
                {children}
            </span>
        );
    }

    return children
};

export const LineHeightPlugin = () => ({
  renderLeaf: renderLineHeightLeaf,
});
